import React from 'react';

import { Steps, BaseModal } from 'components';

import { IStagedModalProps } from './StagedModal.types';

import './StagedModal.styles.scss';

const StagedModal = <T,>({
  children,
  currentStep,
  steps = [],
  stepsProps,
  onChangeStep,
  beforeStepsComponent,
  ...props
}: IStagedModalProps<T>) => {
  const noSteps = !steps || !steps.length;
  const currentStepNumber = steps.findIndex(step => step.key === currentStep);

  const handleChangeStep = (stepNumber: number) => {
    const stepKey = steps[stepNumber]?.key;

    onChangeStep(stepKey);
  };

  return (
    <BaseModal {...props}>
      {beforeStepsComponent}

      {!noSteps && (
        <Steps
          items={steps}
          titlePlacement="vertical"
          current={currentStepNumber}
          onChange={onChangeStep && handleChangeStep}
          className="np-staged-modal__steps"
          {...stepsProps}
        />
      )}

      {children}
    </BaseModal>
  );
};

export default StagedModal;
